'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import useEmblaCarousel from 'embla-carousel-react';
import dynamic from 'next/dynamic';
import { useRouter, useSearchParams } from 'next/navigation';
import { type FC, useCallback, useEffect, useMemo, useState } from 'react';
import { ActionCardSkeleton } from '@/components/molecules/ActionCard';
import { GoldStatusActionCard } from '@/components/molecules/GoldStatusActionCard';
import { actionsListOptions } from '@/entities/Actions/api/actions';
import { NoResults } from '@/entities/Experiences';
import { useUserStore } from '@/entities/User/store/userStoreProvider';
import { PaginationControl } from '@/shared/components/Pagination/PaginationControl';
const ActionCardShellLazy = dynamic(() => import('@/components/molecules/ActionCard/ActionCardShell').then(mod => ({
  default: mod.ActionCardShell
})), {
  loading: () => <div className="bg-gray-800/20 h-[400px] animate-pulse" />
});
type ActionsListProps = {
  celebrityId?: number;
  hidePagination?: boolean;
  limit?: number;
  alowCorousel?: boolean;
  showGoldStatusCard?: boolean;
};
export const ActionsList: FC<ActionsListProps> = t0 => {
  const $ = _c(74);
  const {
    celebrityId,
    hidePagination,
    limit: t1,
    alowCorousel: t2,
    showGoldStatusCard: t3
  } = t0;
  const limit = t1 === undefined ? 18 : t1;
  const alowCorousel = t2 === undefined ? false : t2;
  const showGoldStatusCardProp = t3 === undefined ? true : t3;
  const router = useRouter();
  const searchParams = useSearchParams();
  const user = useUserStore(_temp);
  const showGoldStatusCard = showGoldStatusCardProp && !user?.hasGoldStatus;
  const actualLimit = showGoldStatusCard ? limit - 1 : limit;
  let t4;
  if ($[0] !== searchParams) {
    t4 = searchParams.get("celebrities") ? searchParams.get("celebrities")?.split(",").map(Number) : undefined;
    $[0] = searchParams;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== searchParams) {
    t5 = searchParams.get("celebrityName") ?? undefined;
    $[2] = searchParams;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== searchParams) {
    t6 = searchParams.get("price") ? searchParams.get("price")?.split(",").map(Number) as [number, number] : undefined;
    $[4] = searchParams;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== searchParams) {
    t7 = searchParams.get("sortBy") ?? undefined;
    $[6] = searchParams;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = t7 as 'coinsPrice' | undefined;
  let t9;
  if ($[8] !== searchParams) {
    t9 = searchParams.get("sortType") ?? undefined;
    $[8] = searchParams;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = t9 as 'desc' | 'asc' | undefined;
  let t11;
  if ($[10] !== searchParams) {
    t11 = searchParams.get("type") ?? undefined;
    $[10] = searchParams;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = t11 as string | undefined;
  let t13;
  if ($[12] !== searchParams) {
    t13 = searchParams.get("page") ? Number(searchParams.get("page")) : 1;
    $[12] = searchParams;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t10 || $[15] !== t12 || $[16] !== t13 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t8) {
    t14 = {
      celebrities: t4,
      celebrityName: t5,
      price: t6,
      sortBy: t8,
      sortType: t10,
      type: t12,
      page: t13
    };
    $[14] = t10;
    $[15] = t12;
    $[16] = t13;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t8;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const filters = t14;
  let t15;
  if ($[22] !== router) {
    t15 = page => {
      const url = new URL(window.location.href);
      url.searchParams.set("page", page.toString());
      router.push(url.toString());
    };
    $[22] = router;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  const setPage = t15;
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [];
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  useEffect(_temp2, t16);
  let t17;
  if ($[25] !== actualLimit || $[26] !== celebrityId || $[27] !== filters.celebrities || $[28] !== filters.celebrityName || $[29] !== filters.page || $[30] !== filters.price || $[31] !== filters.sortBy || $[32] !== filters.sortType || $[33] !== filters.type) {
    t17 = actionsListOptions({
      isActive: true,
      page: filters.page,
      limit: actualLimit,
      price: filters.price,
      sortBy: filters.sortBy,
      sortOrder: filters.sortType,
      celebrityId: celebrityId ? [celebrityId] : filters.celebrities,
      type: filters.type === "all" ? undefined : filters.type,
      celebrityName: filters.celebrityName
    });
    $[25] = actualLimit;
    $[26] = celebrityId;
    $[27] = filters.celebrities;
    $[28] = filters.celebrityName;
    $[29] = filters.page;
    $[30] = filters.price;
    $[31] = filters.sortBy;
    $[32] = filters.sortType;
    $[33] = filters.type;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  const {
    data: t18,
    isLoading,
    isFetching
  } = useQuery(t17);
  let t19;
  if ($[35] !== t18) {
    t19 = t18 === undefined ? {
      items: [],
      total: 0,
      page: 0
    } : t18;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  const {
    items: actions,
    total
  } = t19;
  const totalPagesCount = Math.ceil(total / actualLimit);
  let t20;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      loop: true,
      align: "center",
      skipSnaps: false,
      containScroll: "trimSnaps"
    };
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t20);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t21;
  if ($[38] !== emblaApi) {
    t21 = () => {
      if (!emblaApi) {
        return;
      }
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    $[38] = emblaApi;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  const onSelect = t21;
  let t22;
  let t23;
  if ($[40] !== emblaApi || $[41] !== onSelect) {
    t22 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      emblaApi.on("reInit", onSelect);
    };
    t23 = [emblaApi, onSelect];
    $[40] = emblaApi;
    $[41] = onSelect;
    $[42] = t22;
    $[43] = t23;
  } else {
    t22 = $[42];
    t23 = $[43];
  }
  useEffect(t22, t23);
  if (isLoading || isFetching) {
    const t24 = `actions-list grid grid-cols-1 gap-8 sm-tablet:grid-cols-1 tablet:grid-cols-2 tablet:gap-4 2md:grid-cols-2 lg:grid-cols-3 ${alowCorousel ? "hidden md:grid" : ""}`;
    let t25;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = [1, 2, 3].map(_temp3);
      $[44] = t25;
    } else {
      t25 = $[44];
    }
    let t26;
    if ($[45] !== t24) {
      t26 = <div className={t24}>{t25}</div>;
      $[45] = t24;
      $[46] = t26;
    } else {
      t26 = $[46];
    }
    return t26;
  }
  if (!actions?.length) {
    let t24;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <NoResults className="min-h-[314px]" />;
      $[47] = t24;
    } else {
      t24 = $[47];
    }
    return t24;
  }
  const t24 = `actions-list grid grid-cols-1 gap-8 sm-tablet:grid-cols-1 tablet:grid-cols-2 tablet:gap-4 2md:grid-cols-2 lg:grid-cols-3 ${alowCorousel ? "hidden md:grid" : ""}`;
  let t25;
  if ($[48] !== showGoldStatusCard) {
    t25 = showGoldStatusCard && <div key="gold-status"><GoldStatusActionCard /></div>;
    $[48] = showGoldStatusCard;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== actions || $[51] !== user?.hasGoldStatus) {
    let t27;
    if ($[53] !== user?.hasGoldStatus) {
      t27 = (action, index) => <div key={action.id ?? index}><ActionCardShellLazy auctionData={action.auctionData} isLCP={index === 0} key={action.id} id={action.id} type={action.type === "celebrity_card" ? "social_media" : action.type} celebrity={action.celebrity} actionTypeName={action?.actionType?.actionTypeName} title={action.headerText} backgroundImage={action.imageLink} buttonText="vote" buttonIcon={undefined} tokenReward={user?.hasGoldStatus ? action?.actionType?.reward?.poeGoldStatusAmount : action?.actionType?.reward?.poeAmount} gemReward={action?.actionType?.reward?.coinsAmount} tokenCost={action?.actionType?.coinsCost} timeLeft={action.finishDateTime ? new Date(action.finishDateTime) : new Date()} progressCurrent={undefined} progressTotal={undefined} onButtonClick={() => console.warn(`Clicked ${action?.actionType?.reward?.name}: ${action.id}`)} activeQuestionIndex={action?.actionType?.actionTypeName === "quiz_participation" ? action.currentUserProgress?.length ?? 0 : undefined} countQuestions={action?.actionType?.actionTypeName === "quiz_participation" ? action.questions?.length ?? 0 : undefined} /></div>;
      $[53] = user?.hasGoldStatus;
      $[54] = t27;
    } else {
      t27 = $[54];
    }
    t26 = actions.map(t27);
    $[50] = actions;
    $[51] = user?.hasGoldStatus;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[55] !== t24 || $[56] !== t25 || $[57] !== t26) {
    t27 = <div className={t24}>{t25}{t26}</div>;
    $[55] = t24;
    $[56] = t25;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== filters.page || $[60] !== hidePagination || $[61] !== setPage || $[62] !== totalPagesCount) {
    t28 = !hidePagination && totalPagesCount > 1 && <div className="mt-6 pt-3 md:mt-16 md:pt-3"><PaginationControl page={filters.page - 1} totalPages={totalPagesCount} firstPage={() => setPage(1)} lastPage={() => setPage(totalPagesCount)} prevPage={() => setPage(Math.max(1, filters.page - 1))} nextPage={() => setPage(Math.min(totalPagesCount, filters.page + 1))} setPage={page_0 => setPage(page_0 + 1)} /></div>;
    $[59] = filters.page;
    $[60] = hidePagination;
    $[61] = setPage;
    $[62] = totalPagesCount;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== actions || $[65] !== alowCorousel || $[66] !== emblaRef || $[67] !== selectedIndex || $[68] !== user?.hasGoldStatus) {
    t29 = alowCorousel && <div className="block md:hidden"><div className="relative"><div className="overflow-hidden" ref={emblaRef}><div className={`flex${actions.length === 1 ? " justify-center" : ""}`}>{actions.map((action_0, _index) => <div key={action_0.id} className={"flex min-w-0 flex-[0_0_75%] flex-col justify-center px-1" + (_index !== selectedIndex ? " opacity-30" : "")}><ActionCardShellLazy isLCP={_index === 0} auctionData={action_0.auctionData} key={action_0.id} id={action_0.id} type={action_0.type} actionTypeName={action_0.actionType.actionTypeName} title={action_0.headerText} backgroundImage={action_0.imageLink} buttonText="vote" buttonIcon={undefined} tokenReward={user?.hasGoldStatus ? action_0?.actionType.reward.poeGoldStatusAmount : action_0?.actionType.reward.poeAmount} gemReward={action_0?.actionType.reward.coinsAmount} tokenCost={action_0.actionType.coinsCost} timeLeft={action_0.finishDateTime ? new Date(action_0.finishDateTime) : new Date()} progressCurrent={undefined} progressTotal={undefined} onButtonClick={() => console.warn(`Clicked ${action_0.actionType.reward.name}: ${action_0.id}`)} activeQuestionIndex={action_0.actionType.actionTypeName === "quiz_participation" ? action_0.currentUserProgress?.length ?? 0 : undefined} countQuestions={action_0.actionType.actionTypeName === "quiz_participation" ? action_0.questions?.length ?? 0 : undefined} /></div>)}</div></div></div></div>;
    $[64] = actions;
    $[65] = alowCorousel;
    $[66] = emblaRef;
    $[67] = selectedIndex;
    $[68] = user?.hasGoldStatus;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== t27 || $[71] !== t28 || $[72] !== t29) {
    t30 = <>{t27}{t28}{t29}</>;
    $[70] = t27;
    $[71] = t28;
    $[72] = t29;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  return t30;
};
function _temp(store) {
  return store.user;
}
function _temp2() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
function _temp3(i) {
  return <ActionCardSkeleton key={i} />;
}